<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog" :close-on-click-modal="false">
        <el-form ref="formValidate" :model="model" :rules="rules" label-width="120px">
            <el-form-item label="出厂编号：" prop="factory_code">
                <el-input v-model="model.factory_code"></el-input>
            </el-form-item>
            <el-form-item label="品牌：" prop="brand">
                <el-input v-model="model.brand"></el-input>
            </el-form-item>
            <el-form-item label="设备型号：" prop="device_code">
                <el-input v-model="model.device_code"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="handleSubmit" size="medium">确 定</el-button>
            <el-button @click="closeDialog" size="medium">取 消</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { saveModel } from '@/api/common'

export default {
    name: 'flowMeterEdit',
    mixins: [editutil],
    props: {
        device_type: {
            type: Number,
            default() {
                return -1;
            }
        },
    },
    data() {
        return {
            model: {
                device_type: '',
                factory_code: '',
                brand: '',
                device_code: '',
                state: '',
                check_date: '',
                creator_id: '',
                creator_name: '',
                create_time: '',
                update_id: '',
                update_name: '',
                update_time: '',
            },
            getObj:{
                url:'/api/admin/flowmeter/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: [],
            rules: {
                factory_code: [
                    {required: true, message: '出厂编号不能为空', trigger: 'blur'},
                    {validator: this.validExist, trigger: 'blur' }
                ],
                brand: [
                    {required: true, message: '品牌不能为空', trigger: 'blur'}
                ],
                device_code: [
                    {required: true, message: '设备型号不能为空', trigger: 'blur'}
                ],
            },
            checkObj:{
                url:'/api/admin/flowmeter/check',
                data:{
                    device_type: 0,
                }
            },
            exits_p_name:'factory_code',
            exits_p_title:'出厂编号',
        };
    },
    watch: {
        isshow(newv, old) {
            this.showflag = newv;
            if (newv) {
                this.checkObj.data.device_type = this.device_type
                this.resetModel(this.form_name);
                this.loadData();
            }
        }
    },
    methods: {
        //保存方法
        handleSubmit() {
            this.$refs[this.form_name].validate((valid) => {
                if (valid) {
                    this.model.device_type = this.device_type
                    this.formatModel();
                    let config = {
                        url:'/api/admin/flowmeter/save'
                    }
                    config["data"] = this.model;
                    saveModel(config).then(res=>{
                        if(res.code===1){
                            this.$msgs("保存成功！");
                            this.$emit("on-save-ok",{});
                        }else{
                            this.$msg(res.msg)
                        }
                    }).catch();
                }
            })
        },
    }
};
</script>